module.exports = __webpack_public_path__ + "static/media/orange-ic.d5993570.svg";